import { useNavigate } from "react-router-dom";

import  LoginForm  from "../components/LoginForm";

export const Login = () => {
  const navigate = useNavigate();

  return (
    // <Layout title="Log in to your account">
    <LoginForm onSuccess={() => navigate("/app")} />
    // </Layout>
  );
};
